<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  text: {
    type: String,
    default: 'OR'
  }
});
</script>

<template>
  <div class="divider">
    <div class="divider-line"></div>
    <div class="divider-text">{{ props.text }}</div>
    <div class="divider-line"></div>
  </div>
</template>

<style scoped lang="postcss">
.divider {
  @apply flex items-center justify-center w-full py-1;
}

.divider-line {
  @apply flex-grow h-px bg-zinc-700;
}

.divider-text {
  @apply px-4 text-xs text-zinc-500 font-bold;
}
</style> 